// extracted by mini-css-extract-plugin
export default {"window":"modal_window__xSu0U","windowOpened":"modal_windowOpened__KnJaw","closeButton":"modal_closeButton__zs55H"};